import { useRef } from 'react';
import { IWorkspace, getWorkspace } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

const WsWorkspaceFilter = ({ name, onSelect }: WsFilterProps) => {
  const workspaces = useRef<IWorkspace[]>([]);
  const onWorkspaceInputKey = async (query: string) => {
    const response = await getWorkspace(query);
    workspaces.current = response.data ?? [];
    return (
      response.data?.map(
        (workspace) => `${workspace.name} (${workspace.ownerName ?? workspace.ownerId})`
      ) ?? []
    );
  };

  const onWorkspaceNameSelect = (selectedValue) => {
    const selectedWorkspace = workspaces.current.find(
      (workspace) =>
        `${workspace.name} (${workspace.ownerName ?? workspace.ownerId})` === selectedValue
    );

    onSelect && onSelect(selectedWorkspace?.id ?? '');
  };
  return (
    <WsAutocompleteInput
      getOptions={onWorkspaceInputKey}
      onChange={onWorkspaceNameSelect}
      options={[]}
      placeholder="Search for workspace"
      freeSolo={false}
      name={name}
      size="small"
      focused={true}
      required={true}
      requireSelection={false}
    />
  );
};

export default WsWorkspaceFilter;
